import { defineMessages } from 'react-intl';

const messages = defineMessages({
  date: {
    id: 'add-ons.orders.date',
    defaultMessage: 'Date of order'
  },
  eventName: {
    id: 'add-ons.orders.event-name',
    defaultMessage: 'Event'
  },
  buyer: {
    id: 'add-ons.orders.buyer',
    defaultMessage: 'Buyer'
  },
  attendee: {
    id: 'add-ons.orders.attendee',
    defaultMessage: 'Attendee'
  },
  addOn: {
    id: 'add-ons.orders.add-ons',
    defaultMessage: 'Add-on'
  },
  checkInState: {
    id: 'add-ons.orders.check-in-state',
    defaultMessage: 'Status'
  },
  actions: {
    id: 'add-ons.orders.actions',
    defaultMessage: 'Actions'
  },
  name: {
    id: 'add-ons.orders.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'add-ons.orders.email',
    defaultMessage: 'Email',
  },
  sales: {
    id: 'add-ons.orders.sales',
    defaultMessage: 'Sales',
  },
  allDays: {
    id: 'add-ons.orders.all-days',
    defaultMessage: 'Any date of order',
  },
  pastSevenDays: {
    id: 'add-ons.orders.past-7-days',
    defaultMessage: 'Past 7 Days',
  },
  pastThirtyDays: {
    id: 'add-ons.orders.past-30-days',
    defaultMessage: 'Past 30 Days',
  },
  allStatuses: {
    id: 'add-ons.orders.all-statuses',
    defaultMessage: 'Any order status',
  },
  redeemed: {
    id: 'add-ons.orders.redeemed',
    defaultMessage: 'Redeemed',
  },
  notRedeemed: {
    id: 'add-ons.orders.not-redemeed',
    defaultMessage: 'Not redeemed',
  },
  emptyOrders: {
    id: 'add-ons.orders.empty',
    defaultMessage: 'Sorry! There are no orders matching the filters you\'ve chosen'
  },
  eventSearchPlaceholder :  {
    id: 'add-ons.orders.eventSearchPlaceholder',
    description: 'Filter by event',
    defaultMessage: 'Filter by event',
  },
  addOnSearchPlaceholder: {
    id: 'add-ons.orders.addOnSearchPlaceholder',
    description: 'Search add-on',
    defaultMessage: 'Search add-on',
  },
  searchAddon: {
    id: 'add-ons.orders.search-addon',
    defaultMessage: 'Search'
  },
  noEventsFoundOnFilters: {
    id: 'add-ons.filter.noEventsFoundOnFilter',
    defaultMessage: 'No add-on orders yet.\nOrders will be displayed here when received.'
  },
});

export default messages;
